import { apiWrapper } from '../helper/api-wrapper';

export const getDashboard = async () => {
  try {
    const response = await apiWrapper.get(`merchants/dashboard`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const switchActive = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/dashboard/set_active`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDataDashboardDesigner = async () => {
  try {
    const response = await apiWrapper.get(
      `merchant/designer/project/countDataDashBoard`
    );

    return response;
  } catch (error) {
    throw error;
  }
};
